import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

// Loại cuộc họp phân loại: 1 = Nội bộ, 2 = Khách (khớp enum MeetingAudienceType của BE)
export type MeetingAudienceType = 1 | 2

// Một người trong thành phần cuộc họp (khớp CompositionMember của BE)
export interface CompositionMember {
  userId: string
  fullName: string
  accountType: number | null
  phoneNumber: string | null
  email: string | null
  departmentNames: string | null
  // Do getDetail trả: 1 Tham gia · 2 Không tham gia · 3 Chưa phản hồi; participant-options không điền
  participationStatus?: number | null
  reason?: string | null
}

const initialState: {
  employees: any[]
  allEmployees: any[]
  filterAllEmployees: any
  filterAllDelegates: any
  delegates: any[]
  allDelegates: any[]
  info: any
  // Luồng phân loại Nội bộ/Khách — tách khỏi delegates (AccountType=4)
  audienceType: MeetingAudienceType | null
  guests: CompositionMember[]
  attendees: CompositionMember[]
} = {
  employees: [],
  allEmployees: [],
  filterAllEmployees: {},
  filterAllDelegates: {},
  delegates: [],
  allDelegates: [],
  info: {},
  audienceType: null,
  guests: [],
  attendees: [],
}

const MeetingSlice = createSlice({
  name: 'Meeting',
  initialState,
  reducers: {
    reset: () => initialState,
    setInfo: (state, action) => {
      state.info = action.payload
    },
    setPartcipants: (state: any, action) => {
      state[action.payload.type] = action.payload.list
    },
    setFilterAllEmployees: (state, action) => {
      state.filterAllEmployees = action.payload
    },
    setFilterAllDelegates: (state, action) => {
      state.filterAllDelegates = action.payload
    },
    setAudienceType: (state, action: PayloadAction<MeetingAudienceType | null>) => {
      state.audienceType = action.payload
    },
    setGuests: (state, action: PayloadAction<CompositionMember[]>) => {
      state.guests = action.payload
    },
    setAttendees: (state, action: PayloadAction<CompositionMember[]>) => {
      state.attendees = action.payload
    },
    deleteParticipant: (state: any, action) => {
      state[action.payload.type] = (state[action.payload.type] as any[]).filter(
        (item) => item.id !== action.payload.id
      )
    },
  },
})

export const {
  reset,
  setInfo,
  setPartcipants,
  setFilterAllEmployees,
  setFilterAllDelegates,
  setAudienceType,
  setGuests,
  setAttendees,
  deleteParticipant,
} = MeetingSlice.actions
export default MeetingSlice.reducer
